export default __webpack_public_path__ + "static/media/WatchLater.3ca73ea2.svg";